<template>
  <Select
    v-model="selectData"
    :filterable="filterable||allowInput"
    :remote="remote"
    :multiple="multiple"
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    :disabled="disabled"
    :clearable="clearable"
    :focused="isFocused"
    :allowInput="allowInput"
    @on-clear="onMyClear"
    @on-blur="onBlur"
    @on-focus="onFocus"
    @on-change="change"
    @on-open-change="open"
    @on-query-change="inputChange"
  >
    <Option v-for="(item,index) in dataList" :value="item[code]" :key="index">{{item[label]}}</Option>
  </Select>
</template>
<script>
/**
 * 如果需要级联，需要配置cascade、me 和ref。可以参考region组件
 <dropdown v-model="selectData" :disabled="disabled" :dataCfg="userTypeDataCfg" :label="'itemName'" :code="'itemCode'"></dropdown>
 在data里面配置数据源配置
 userTypeDataCfg:{
    sc:"permission",
    url:'lookUpManage/listPermissionTypeAndSys',
    params:{"classifyCode":"ihlp.som.permission.type"}
}
 */
import Select from "./select/select.vue";
import Option from "./select/option.vue";
import OptionGroup from "./select/option-group.vue";
export default {
  name: "ihlpDropdown",
  components: { Select, Option, OptionGroup },
  props: {
    value: {
      type: [String, Array,Number],
      default: ""
    },
    label: {
      type: String,
      default: "label"
    },
    code: {
      type: String,
      default: "value"
    },
    //是否开始就获取焦点
    isFocused: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    //是否可以筛选，如果筛选后不选择，离开后清空筛选值
    filterable: {
      type: Boolean,
      default: false
    },
    //是否允许输入为有效值
    allowInput: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    size: {
      type: String,
      default: "default"
    },
    domParamsCfg:{
        type: Object
    },
    dataCfg: {
      type: Object,
      default: function() {
        return {
          sc: "",
          url: "",
          params: {}
        };
      }
    },
    remoteMethod: {
      type: Function
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //自动初始化下拉数据列表
    autoInit: {
      type: Boolean,
      default: false
    },
    //自动选则第一项，需要autoInit为true
    autoSelectOne: {
      type: Boolean,
      default: false
    },
    //组件初始化前
    onBeforeInit: {
      type: Function
    },
    //初始化数据调用服务前
    onBeforeInitData: {
      type: Function
    },
    //初始化数据前
    onBeforeSetDataList: {
      type: Function
    },
    onAfterInitData: {
      type: Function
    },
    onChange: {
      type: Function
    },
    onClear: {
      type: Function
    },
    onAfterChange: {
      type: Function
    },
    onOpenChange: {
      type: Function
    },
    onAfterOpenChange: {
      type: Function
    },
    onQueryChange: {
      type: Function
    },
    me: {
      type: Object
    },
    cascade: {
      type: Object
    }
  },
  data() {
    return {
      selectData: "",
      loading: true,
      dataList: [],
      repeatMaxCount: 5,
      repeatCount: 1,
      getDataByCodeP: {},
      getDataByCodePRes: {},
      getDataByCodePRej: {},
      isAllowInput:false,
      isValueWatch:false
    };
  },
  mounted() {
    let self = this;
    this.getDataByCodeP = new Promise(function(resolve, reject) {
      self.getDataByCodePRes = resolve;
      self.getDataByCodePRej = reject;
    });
    this.init();
    this.selectData = this.multiple ? [] : "";
  },
  methods: {
    init() {
      if (this.value) {
        this.initSetData(this.value);
      } else if (this.autoInit) {
        this.dataSet();
      }
    },
    //初始化数据。在下拉服务未调用前，如果设置了数据则会触发该方法。
    initSetData(value) {
      let self = this;
      let p = self.dataSet();
      //如果有设置级联，则判断父项是否有值，没值则延迟再初始化
      if (p === "cascadeNoPid") {
        //限制重复次数
        if (self.repeatCount <= self.repeatMaxCount) {
          setTimeout(() => {
            self.initSetData(value);
            self.repeatCount++;
          }, 500);
        }
      } else {
        p.then(
          s => {
            self.selectData = value;
          },
          e => {}
        );
      }
    },
    //设置数据源
    dataSet() {
      let self = this;
      let dataCfg = self.dataCfg;

      //下拉级联
      if (self.cascade) {
        //需要使用vue页面的this，通过refs来完成
        let me = this.me;
        if (self.cascade.from) {
          let seData = me.$refs[self.cascade.from].getSelectData();
          if (!seData) {
            return "cascadeNoPid";
          } else if (self.cascade.paramsStr) {
            dataCfg.params[self.cascade.paramsStr] = seData;
          }
        }
      }

      //调用服务
      return new Promise(function(resolve, reject) {
        if (self.$utils.isEmptyObject(dataCfg)) {
          reject(false);
        } else if (dataCfg.value) {
          self.loading = false;
          self.dataList = dataCfg.value;
          self.$nextTick(function() {
            self.getDataByCodePRes(self.dataList);
            //初始化下拉数据列表后回调
            self.$emit("onAfterInitData", self, self.dataList);
            resolve(true);
          });
        } else {
          //调用服务前
          self.$emit("onBeforeInitData", self, dataCfg);
          let params=Object.assign({},dataCfg.params,self.domParamsCfg);
          //调用服务
          self.$api.post({
            sc: dataCfg.sc,
            url: dataCfg.url,
            params: params,
            success: r => {
              self.loading = false;

              //调用服务前
              var aaa = self.$emit("onBeforeSetDataList", r, self, dataCfg);
              let list = r.result || [];
              self.dataList = list;
              //自动选择第一个值
              if (self.autoSelectOne) {
                let value = list.length > 0 ? list[0][self.code] : "";
                self.selectData = value;
                self.change(value);
              }
              self.$nextTick(function() {
                self.getDataByCodePRes(list);
                //初始化下拉数据列表后回调
                self.$emit("onAfterInitData", self, list);
              });
              resolve(true);
            }
          });
        }
      });
    },
    open(value) {
      if (this.dataList.length == 0 && value == true) {
        this.dataSet();
      }
    },
    change(value) {
      this.$emit("input", value);
      this.$emit("onChange", value);
      //下拉级联,清空子项值和子项选项值
      if (this.cascade && this.cascade.to) {
        //需要使用vue页面的this，通过refs来完成
        let me = this.me;
        if (me.$refs[this.cascade.to]) {
          let value = this.multiple ? [] : "";
          me.$refs[this.cascade.to].setValue(value);
          me.$refs[this.cascade.to].setDataList([]);
        }
      }
    },
    inputChange(data) {
      //判断如果配置了可以输入不存在下拉框中的值也生效
      if(this.allowInput&&!this.isValueWatch&&!this.multiple){
        this.isAllowInput=true
        this.$emit("input", data);
      }else{
        this.isValueWatch=false
      }
      this.$emit("on-query-change", data);
    },
    setValue(data) {
      this.selectData = data;
      // this.change(data)
    },
    setDataList(datas) {
      this.dataList = datas;
      this.loading = datas&&datas.length>0?false:true;
    },
    getDataList() {
      return this.dataList;
    },
    getSelectData() {
      return this.selectData;
    },
    getDataByCode(value) {
      let data = {};
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];
        if (item[this.code] == value) {
          data = item;
          break;
        }
      }
      return data;
    },
    //异步通过code获取选中的值，通常是在初始化的时候，设置了值，下来列表服务数据还没有返回时使用
    getDataAsyncByCode(value) {
      let self = this;
      let getDataAsyncByCodeP = new Promise(function(resolve, reject) {
        self.getDataByCodeP.then(
          function(dataList) {
            let data = {};
            for (let i = 0; i < dataList.length; i++) {
              let item = dataList[i];
              if (item[self.code] == value) {
                data = item;
                break;
              }
            }
            resolve(data);
          },
          function() {
            reject("error");
          }
        );
      });
      return getDataAsyncByCodeP;
    },
    addData(data) {
      this.dataList.push(data);
    },
    addDataList(dataList) {
      this.dataList = this.dataList.concat(dataList);
    },
    onBlur() {
      this.query
      this.$emit("on-blur", this.filterable);
    },
    onFocus(){ 
      this.$emit("on-focus", this.filterable);
    },
    onMyClear(){
      this.$emit("onClear");
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === "") {
        this.selectData = this.multiple ? [] : "";
      }else if(this.isAllowInput){
        this.isAllowInput=false
        return false
      } else if (
        newValue != oldValue &&
        newValue != this.selectData &&
        this.dataList.length == 0
      ) {
        this.initSetData(newValue);
      } else if (newValue != oldValue) {
        this.setValue(newValue);
      }
      this.isValueWatch=true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/dropdown.vue